import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-temp',
  templateUrl: './temp.component.html',
  styleUrls: ['./temp.component.scss']
})
export class WifeTempComponent implements OnInit {

  deceased = this.appState.get();

  constructor(public appState: AppService, public router: Router) {
  		this.appState = this.appState;
  		console.log(this.deceased);
  }

  /* Temp Marriage Inheritance Custom Radio Button */
  toggleWifeInheritance(i, event: any) {
    if( this.deceased.wife.temp.inheritance_condition[i] == 'true' ) {
      this.deceased.wife.temp.inheritance_condition[i] = 'false';
    } else {
      this.deceased.wife.temp.inheritance_condition[i] = 'true';
    }

    event.preventDefault();
  }

  // Back Button
  back(event) {
  	this.router.navigate(['']);
  	event.preventDefault();
  }

  // Next Button is clicked
  next(event) {
  	this.appState.set(this.deceased);

  	if( this.deceased.wife.temp.count > 0 ) {

  		// Temp. Wives Check if any has Inheritance of "Yes", take them to Not Supported Screen
        for (var i = 0; i < this.deceased.wife.temp.count; ++i) {
          if( this.deceased.wife.temp.inheritance_condition[i] == "true" ) {
        	this.router.navigate(['not-supported']);    
        	event.preventDefault();
        	return false;
          }
        }

        // If ALL Good Redirect to Divorced Wife Info Page
        if( this.deceased.wife.divorced.count > 0 ) {
	  		  this.router.navigate(['wife/divorced']);
    		// Else goto Results
    		} else {
    	  		this.router.navigate(['level1-inheritors']);
    		}

 	}

	event.preventDefault();

  }

  ngOnInit() {
  }

}
